<template>
  <el-dialog
    v-if="dialogVisible"
    title="三方租赁合同主体变更提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
    append-to-body
  >
    <div class="container">
      <div>变更主体必须关闭该合同,重新创建合同</div>
      <div>是否关闭该合同?</div>
    </div>
    <div class="btn-group">
      <el-button @click="confirmHandler">关闭合同</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import leaseContractApi from '@/api/park/leaseContract';
  export default {
    name: 'ChangPrimaryDialog',
    data() {
      return {
        dialogVisible: false,
        currentContractId: null,
      };
    },
    methods: {
      openDialog(currentContractId = -1) {
        this.currentContractId = currentContractId;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      // 确认关闭
      async confirmHandler() {
        const { data } = await this.$axios.post(`${leaseContractApi.CLOSE_CONTRACT_BY_ID}`, {
          id: +this.currentContractId,
        });
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.cancelHandler();
          this.$emit('refreshTable');
        } else {
          this.$message.error(data.msg);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
